import React from "react";
import Grid from "@mui/material/Grid";
import Slider from "react-slick";
import { getAssets } from "@unisearch/helpers";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./partner.module.scss";

export const PartnerSection = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
    ],
  };

  return (
    <section className={styles.section_partner}>
      <div className="container">
        <h2 className={`${styles.title} center`}>Our University Partners</h2>
        <p className={`${styles.sub_title} font-xlarge center`}>
          We collaborate with 1,300+ higher education providers around the world
        </p>

        <div className="partner_slider">
          <Slider {...settings}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets(
                  "assets/images/partner/kings_college_london_logo.png"
                )}
                alt="Kings College London"
              />
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets(
                  "assets/images/partner/australian_national_university.png"
                )}
                alt="Australian National University"
              />
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets(
                  "assets/images/partner/univesity_of_cincinnaty.png"
                )}
                alt="Univesity of cincinnaty"
              />
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets(
                  "assets/images/partner/university_of_manitoba.png"
                )}
                alt="University of Manitoba"
              />
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/partner/university_of_york.png")}
                alt="University of York"
              />
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/partner/hec_paris.png")}
                alt="HEC Paris"
              />
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default PartnerSection;
